import React from "react"
import clsx from "clsx"
import Link from "next/link"
import { TableType } from "@/libs/types"
import OverlayTriggerCustomized from "../OverlayTriggerCustomized"

interface PricingContentTableProps {
    locale: string
    table: TableType
}

const PricingContentTable: React.FC<PricingContentTableProps> = ({ locale, table }) => {
    if (table.rows && (table.rows.length === 0)) return null

    return (
        <>
            <table className={clsx('w-100', table.classes)} data-ui="module:ui:ContentTable" id={`table-${table?.id}`}>
                <tbody>
                    {table.rows.map((row: any, index: number) => {
                        if (row.cols && row.cols.length === 0) return null

                        return (
                            <tr key={index}>
                                {row.cols.map((col: any, index: number) => {
                                    if (col.checkbox === false) {
                                        return (
                                            <td className={index === 0 ? 'w-40' : col.classes} key={index}>
                                                <div className="un-checked" />
                                            </td>
                                        )
                                    }
                                    if (col.checkbox) {
                                        return (
                                            <td className={index === 0 ? 'w-40' : col.classes} key={index}>
                                                <div className="checked" />
                                            </td>
                                        )
                                    }

                                    return (
                                        <td className={index === 0 ? 'w-40' : col.classes} key={index}
                                        >
                                            {(col.linked && col?.linked?.href) ?
                                                <Link href={`/${locale}/${col.linked?.href?.split(',').join('/')}`}
                                                    className={clsx(col.linked?.classes, col.linked?.button ? 'btn  flex-wrap-none' : '', '')}
                                                    passHref key={index}>
                                                    {col.linked?.text}
                                                </Link> :
                                                <p className="d-flex mb-0">
                                                    {col.content?.match(/^--/) ?
                                                        <span>&emsp;&emsp;{col.content.replace("--", "-")}</span>
                                                        : col.content?.match(/^-/) ?
                                                            <span>&emsp;{col.content}</span> : col.content}
                                                    {/*{!!col.explaination && <OverlayTriggerCustomized explaination={col.explaination} />}*/}
                                                    {(col.linked && !col?.linked?.href && !col?.linked?.button) &&
                                                        <span className="chip" />}
                                                </p>}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

export default PricingContentTable